export const testAttributes = {
    TRUSTPILOT_CONTAINER: 'trust_pilot_container',
    TRUSTPILOT_SCRIPT: 'trust_pilot_script',
}

export const defaultAttributes = {
    TEMPLATE: '53aa8912dec7e10d38f59f36',
    BUSINESS: '4bed9e1a00006400050b9bca',
    URL: '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'
}